// extracted by mini-css-extract-plugin
export default {"articleTitle":"companyDescription_articleTitle__8gjHB"};